import React from 'react'
import styled, { css, keyframes } from 'styled-components'

import {
  Spinner,
  Button,
  Container,
  Row,
  Col,
  Card,
  Carousel,
  ProgressBar,
  Image,
  Form,
} from 'react-bootstrap'

import { LOGIN_VIEW, OTP_VIEW, ONBOARDING_VIEW } from '../resources/appRoutes'

const ICONS = {
  check: '\f00c',
}

const primary = '#B4CAE5'
const primaryVariant = '#118785'
const secondary = '#FCBC6E'
const secondaryVariant = '#00444a'

const green = '#168886'
const grey = '#e6e6e6'
const black = '#000000'
const white = '#ffffff'

export const headerHeight = 60
export const footerHeight = 80
const videoHeight = 180
const progressIconDimension = '3rem'

//padding removed from viewcontainer and added to maincontainer

export const MainContainer = styled.div`
  background-color: ${(props) => props?.bgcolor};
  height: ${(props) => props?.height};
  padding: ${(props) => (props.padding ? props.padding : '16px')};
  text-align: ${(props) => props?.textAlign};
  border-radius: ${(props) => props?.borderRadius};
  &::-webkit-scrollbar {
    display: none;
  }
  .right {
    border: 2px solid green;
  }
  .wrong {
    border: 2px solid red;
  }
`

export const PrimaryCard = styled(Card)`
  background-color: ${(props) => props?.bgcolor} !important;
  font-weight: 500;
  font-size: 1.5rem;
  text-align: center;
  border-radius: 8px !important;
`
export const SecondaryCard = styled(PrimaryCard)`
  background-color: ${secondary} !important;
`

export const SecondaryVariantCard = styled(PrimaryCard)`
  background-color: #cddc39 !important;
`

export const VideoFrame = styled.div`
  width: 100%;
  border-radius: 8px;
  height: ${(props) => props.height || videoHeight}
  padding: ${(props) => (props.padding ? props.padding.toString() + 'px' : '')};
`

export const VideoIframe = styled.iframe`
  width: 100%;
  border-radius: 8px;
  height: ${(props) => props.height || videoHeight}
  padding: ${(props) => (props.padding ? props.padding.toString() + 'px' : '')};
`

export const ListContainer = styled.div`
  overflow: hidden scroll;
  height: ${(props) =>
    `calc(100vh - ${
      videoHeight + headerHeight + footerHeight + props.bottomoffset
    }px)`};
  &::-webkit-scrollbar {
    display: none;
  }
`

export const Label = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 27px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.lines || 1};
  -webkit-box-orient: vertical;
  margin: 10px 0;
`

export const CongratsLabel = styled(Label)`
  font-size: 2rem !important;
  line-height: 35px;
`

export const CarouselImage = styled.div`
  position: relative;
  height: ${(props) => props.height.toString() + 'px' || '180px'};
  border-radius: 8px
  margin-bottom: 32px;
  background: url(${(props) =>
    props.background}) no-repeat center center / contain;
`

export const AppCarouselImage = styled(CarouselImage)`
  border: 1px solid ${secondary};
  height: 160px;
`

export const CarouselImageContent = styled.img`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 30px;
`

export const ScoreCard = styled.div`
  border-radius: 8px;
  width: 100%;
  color: ${secondaryVariant}
  background: ${secondary};
  padding-top: 8px;
`

export const VerticalDivider = styled.span`
  padding-top: 16px;
  padding-bottom: 16px;
  height: 76px;
  width: 1px;
  background: ${secondaryVariant};
`
export const FlexVerticalDevider = styled.span`
  width: 1px;
  padding-top: 16px;
  padding-bottom: 16px;
  background: ${secondary};
`

export const BorderedCard = styled.div`
  position: relative;
  z-index: 0;
  border-radius: 8px;
  border: 2px solid ${secondary};
  background-color:${(props) => props?.bgcolor}
  // background: ${(props) => (props.filled ? secondary : '')};
  padding: ${(props) => props?.padding};
  // margin-bottom: 32px;
  text-align: ${(props) => (props.centered ? 'center' : '')};
  min-height: ${(props) => (props.height ? props.height + 'px' : '')};
  height: ${(props) =>
    props.fullheight
      ? `calc(100vh - ${footerHeight + headerHeight + 150}px)`
      : props.fit
      ? `calc(100vh - ${footerHeight + headerHeight + 180}px)`
      : ''};
`

export const ErrorContainer = styled.div`
  text-align: center;
  padding: 32px;
`

export const OtpErrorContainer = styled.div`
  text-align: center;
  padding: 10px;
`

export const LoaderContainer = styled.div`
  text-align: center;
  height: 100%;
  position: relative;
`

export const Spin = styled(Spinner)`
  position: absolute;
  left: 44%;
  top: 45%;
`

export const ErrorCode = styled(Label)`
  font-size: 2rem
  font-wight: 600
`
export const ErrorMessage = styled(Label)`
  font-size: 1.4rem
  font-wight: 600
  margin-bottom: 16px
`

export const Logout = styled.h5`
  color: #696969;
  text-decoration: underline;
`

export const ResultImage = styled(Image)`
  margin-bottom: 32px;
`

export const Header = styled.div`
  // z-index: 1000;
  // position: fixed;
  width: 100%;
  height: ${headerHeight}px;
  background-color: ${(props) =>
    props.view === '/onboarding' ? white : '#FFDD50'};
  border-bottom: 2px solid burlywood;
`

export const Footer = styled.div`
  // position: fixed;
  width: 100%;
  height: ${footerHeight}px !important;
  background-color: ${white};
  // bottom: 0;
  padding: 8px;
  border-top: 1px solid ${secondary};
`

export const ContentCarousel = styled(Carousel)`
  width: 100%;
`
const publicRoutes = [LOGIN_VIEW, OTP_VIEW, ONBOARDING_VIEW]

// export const MainContainer = styled(Container)`
//   padding-top: ${props =>
//     !publicRoutes.includes(props.path) ? headerHeight : '0'}px;
//   padding-bottom: ${props =>
//     !publicRoutes.includes(props.path) ? footerHeight : '0'}px;
//   padding-right: 0 !important;
//   padding-left: 0 !important;
//   &::-webkit-scrollbar: {
//     display: none;
//   }
// `

export const HomeContainer = styled.div`
  padding: 16px;
`

export const MainScore = styled.p`
  padding: 0
  font-size: 2.4rem
  font-weight: 600
`

export const MenuLabel = styled.p`
  font-weight: ${(props) => (props.active ? 500 : 400)};
  font-size: 22px;
`

export const MoreButton = styled.span`
  font-size: 0.8rem;
  color: ${primaryVariant};
`

export const Description = styled.div`
  font-size: 1rem;
  min-height: 21px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.lines || 2};
  -webkit-box-orient: vertical;
`

export const CongratsDescription = styled(Description)`
  font-size: 1.3rem !important;
  line-height: 30px;
`

export const SliderSection = styled.section`
  background-color: #fff;
  width: 100%;
  min-height: ${(props) =>
    props.height ? props.height.toString() + 'px' : '160px'};
  display: flex;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const SliderCard = styled.div`
  background-color: #e74c3c;
  width: ${(props) => (props.width ? props.width.toString() + 'px' : '160px')};
  height: ${(props) => (props.circle ? props.width.toString() + 'px' : '160px')}
  margin-left: 8px;
  margin-right: 8px;
  border-radius: ${(props) => (props.circle ? '50%' : '8px')};
  background: url(${(props) =>
    props.background}) no-repeat center center / cover;
  border: ${(props) =>
    props.selected ? `2px solid ${secondaryVariant}` : `1px solid ${primary}`}
  padding: 4px;
  background-origin: content-box;
  
`

export const SliderCardLabel = styled.div`
  color: ${(props) => (props.selected ? secondaryVariant : primaryVariant)};
  font-weight: ${(props) => (props.selected ? '500' : '')};
  text-align: center;
  margin-top: 4px;
  font-size: 2vh;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.lines || 2};
  -webkit-box-orient: vertical;
`

export const ShareContainer = styled.div`
  text-align: center;
  width: 100%;
`

export const AppThumbnail = styled(Col)`
  background: url(${(props) => props.thumbnail + ``}) no-repeat center center /
    cover;
  height: ${(props) =>
    props.height ? props.height.toString() + 'px' : '160px'};
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
`

export const CardTitle = styled.div`
  font-size: 1.6rem;
  font-weight: 500;
  margin-bottom: 8px;
  line-height: 1.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.lines || 2};
  -webkit-box-orient: vertical;
`

export const CardDescription = styled.div`
  opacity: 0.8;
  font-size: ${(props) => props.fontSize || '1.3rem'};
  line-height: 1.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.lines || 2};
  -webkit-box-orient: vertical;
`

export const SocialArea = styled.span`
  margin: 0 auto;
  display: flex;
`

export const QuestionText = styled.div`
  // background-color:#B4CAE5;
  background-color:white
  border-radius:5px;
  padding:10px;
  font-size: 1.4rem;
  font-weight: 500;
  // margin-top: 16px;
`

export const ViewContainer = styled.div`
  background: ${(props) => (props.view === 'leaderBoard' ? primary : white)};
  // padding: 16px;
  overflow: hidden scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const ProviderContainer = styled.div`
  text-align: center;
  margin-top: 20px;
`

export const Provider = styled(Image)`
  height: 30px;
  margin: 8px;
`

// replaced  with maincontainer

export const LoginContainer = styled.div`
  padding: 16px;
  text-align: center;
`

export const Input = styled.input`
  margin-bottom: 12px;
  width: 100%;
  height: 60px;
`

export const CSFInput = styled.input`
  border: 0 !important;
  border-bottom: 1px solid ${secondaryVariant} !important


  &:focus {
    border: 0 !important;
  }
`

export const ProfileInput = styled(CSFInput)`
  border-color: ${secondaryVariant};
  border-width: 0 0 2px 0;
  padding: 8px 8px 8px 4px;
  width: 100%;

  &:focus {
    border: 1px solid transparent !important;
  }

  ${(props) =>
    props.error &&
    css`
      border: 1.5px solid red !important;
    `};
`

export const HorizontalDivider = styled.hr`
  border-top: 1px solid ${(props) => props?.color};
  margin: 3px 0px;
`

export const ChoicesContainer = styled.div`
  // margin-bottom: 48px;
  // margin-top: 16px;

  // @media (max-height: 576px) {
  //   margin-bottom: 12px;
  // }

  // @media (max-height: 768px) {
  //   margin-bottom: 18px;
  // }
`

export const Timer = styled.div`
  font-size: 1.2rem;
`

export const ResultContainer = styled.div`
  text-align: center;
  padding: 35px;
  margin-bottom: 16px;
`

export const ChoiceCard = styled.div`
  padding: 16px;
  border-radius: 8px !important;
  background: ${(props) => {
    if (props.selectedAns) {
      return props.selectedAns
    } else {
      return props.correct ? '#39c979' : props.wrong ? '#EBAEAF' : props.bgcolor
    }
  }} !important;
  margin-top: 10px;
  color: ${secondaryVariant};

  @media (max-height: 576px) {
    padding: 8px;
    margin-bottom: 12px;
  }

  @media (min-height: 577px and max-height: 768px) {
    padding: 12px;
    margin-bottom: 18px;
  }
`

export const Choice = styled.span`
  font-size: 1.4rem;
  font-weight: 600;
`

export const PrimaryButton = styled(Button)`
  background-color: ${primaryVariant} !important;
  font-weight: 500;
  border: 1px solid ${primary} !important;
  height: ${(props) => (props.height ? props.height.toString() + 'px' : '')};
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
`
export const LinkButton = styled(Button)`
  color: ${secondaryVariant} !important;
  text-decoration: underline !important;
`

export const SecondaryButton = styled(PrimaryButton)`
  background-color: ${secondary} !important;
  color: ${secondaryVariant} !important;
  border: 1px solid ${secondary} !important;
`

export const QuizProgress = styled(ProgressBar)`
  background-color: ${grey} !important;
`

export const Title = styled.div`
  text-align: ${(props) => (props.centered ? 'center' : '')};
  width: 100%;
  font-size: 1.6rem;
  font-weight: 500;
`

export const ListRow = styled(Row)`
  background: ${(props) => (props.active ? secondary : '')} !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 8px;
  border-radius: 8px;
  padding: 8px !important;
`

export const VerticalContainer = styled.div`
  max-height: calc(100vh - ${headerHeight + footerHeight + 200}px);
  padding: 16px !important;
  overflow: hidden scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const AccordianHeader = styled(Card.Header)`
  border-bottom: 0 !important;
  background-color: ${(props) =>
    props.active ? '#ff8d85' : primary} !important
  display: flex;
  justify-content: space-between;
`

export const AccordionBody = styled(Card.Body)`
  background-color: #ff8d85;
`

export const ListThumbnail = styled.div`
  padding: 0px !important;
  background: url(${(props) => props.thumbnail + ``}) no-repeat center center /
    contain;
  height: 100px;
  border-radius: 8px 8px 0px 0px;
`

export const ListCard = styled(Card)`
  border-radius: 8px !important;
  background-color: ${(props) =>
    props.active ? secondary : 'white'} !important;
  margin-bottom: 16px;
  height: 60px;
`

export const Score = styled.span`
  font-size: 1.2rem;
  font-weight: 500;
  color: grey;
`

export const VerticalProgressIcon = styled.div`
    height: ${progressIconDimension};
    width: ${progressIconDimension};
    background-color: ${(props) =>
      props.disabled ? secondaryVariant : primary};
    border-radius: 50%;
    margin: 0 auto;
    padding: 2px;
    background-clip: content-box;
    border: 2px solid ${(props) =>
      props.disabled ? secondaryVariant : primary}
  }
`

export const VerticalProgressTitleContainer = styled.span`
  display: flex;
`

export const VerticalLine = styled.div`
  height: 64px;
  width: 2px;
  background: ${(props) => (props.disabled ? primary : secondaryVariant)};
  margin: 0 auto;
`

export const VerticalTimelineDescription = styled.div`
  display: flex;
`

export const VerticalLineContainer = styled.div`
  width: ${progressIconDimension}px;
  text-align: center;
  margin-right: 16px;
`

export const VerticalProgressItem = styled.div`
  text-align: center;
`

export const QuizCheck = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 20px;
  margin-right: 6px;
  border-radius: 50%;
  border: 3px solid ${(props) => props.border};
  dispplay: flex;
  align-items: center;
  padding: 12px;
`

export const ImageChoiceCard = styled.div`
  height: 120px;
  margin: 8px;
  padding: 0px;
  border-radius: 4px;
  background: url(${(props) => props.url + ``}) no-repeat center center / cover;
`

export const ImageChoiceCol = styled.div`
  border-radius: 8px;
  background-color: ${(props) => {
    if (props.selectedAns) {
      return props.selectedAns
      // return props.correct || props.wrong ? 'white' : '#B4CAE5'
    }

    return props.correct ? '#39c979' : props.wrong ? '#EBAEAF' : grey
  }};
`

export const menuStyles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '20px',
    height: '16px',
    left: '20px',
    top: '20px',
  },
  bmBurgerBars: {
    background: green,
  },
  bmBurgerBarsHover: {
    background: '#a90000',
  },
  bmCrossButton: {
    height: '24px',
    width: '24px',
  },
  bmCross: {
    background: '#bdc3c7',
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%',
  },
  bmMenu: {
    background: '#373a47',
    padding: '2.5em 1.5em 0',
    fontSize: '1.15em',
  },
  bmMorphShape: {
    fill: '#373a47',
  },
  bmItemList: {
    color: '#b8b7ad',
  },
  bmItem: {
    display: 'inline-block',
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)',
  },
}

export const CarouselBreakPoints = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
}

export const AppCarouselBreakPoints = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
    partialVisibilityGutter: 48,
  },
}

export const ListLoader = styled.div`
  text-align: center;
  font-size: 0.9rem;
  color: ${primary};
`

export const Icon = styled.i`
  color: ${(props) => props.color || primaryVariant}
  font-size: ${(props) => props.size.toString() + 'px'}
`

export const PhoneInput = styled(Form.Control)`
  border: 0px !important;
  margin-bottom: 16px;
  outline: none !important;
  width: ${(props) =>
    props.width ? props.width.toString() + 'rem !important' : '100%'};
  height: 40px;
  font-size: 1.2rem;
  color: ${secondaryVariant};
  // border-bottom: 2px solid ${secondaryVariant} !important;
  text-align: center;
  border-radius: 0 !important;
  &:focus {
    outline: none !important;
    box-shadow: none;
  }
`

export const CountryCode = styled(Col)`
  height: 100%;
  font-size: 1.2rem;
  margin-top: 7px;
  width: 24px;
  font-weight: 600;
`

export const ProfileInputControl = styled(PhoneInput)`
  text-align: left;
  background-color: ${(props) => props.bgcolor} !important;
  border-radius: 5px !important;
  padding: 25px !important;
`

export const ResendOtp = styled.span`
  cursor: pointer;
  font-size: 1.1rem;
  color: black;
  margin-top: 16px;
  font-weight: 500;
  opacity: ${(props) => (props.active ? 1 : 0.5)};
`

export const UploaderLabel = styled.span`
  cursor: pointer;
  font-size: 0.8rem;
  color: ${primaryVariant};
`

export const CountDown = styled.div`
  font-size: 1.2rem;
  color: black;
  opacity: 0.5;
`

export const LegalContainer = styled.div`
  overflow: hidden scroll;
  max-height: calc(100vh - ${headerHeight + footerHeight + 180}px);
  &::-webkit-scrollbar {
    display: none;
  }
`

export const Number = styled.span`
  color: ${(props) => (props.disabled ? secondaryVariant : primary)};
  font-size: 1.7rem
  font-weight: 600
`

export const BreathingIcon = styled(VerticalProgressIcon)`
  animation: breathing 7s ease-out infinite normal;
  -webkit-font-smoothing: antialiased;
`

export const WaterMark = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  opacity: 0.2;
  z-index: -1;
  background: url(${(props) => props.background}) no-repeat center center /
    cover;
`

export const OnboardingVideoContainer = styled.div`
  position: relative;
`

export const OnboardingShimmerWrapper = styled.div`
  display: ${(props) => (!props.show ? 'none' : '')};
  position: absolute;
  top: 48%
  left: 50%;
  transform: translate(-50%, -50%);
  width: 101%;
`

export const DateContainer = styled(Col)`
  font-size: 1.4rem;
  font-weight: bold;
  background: #118785;
  border-radius: 8px;
  color: #fff;
`

export const AnimateBubbles = styled.div`
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;

  height: 70px;
  position: absolute;
  width: 70px;
`

export const RewardsContainer = styled.div.attrs((props) => ({
  className: 'flex-grow-1 overflow-auto',
}))`
  &::-webkit-scrollbar {
    display: none;
  }
`

export const Skeleton = styled.div`
  height: 45vw;
  width: 100vw
  margin-left: calc(50% - 50vw);
  background-color: #e2e5e7;
  background-image: linear-gradient(
    90deg,
    rgba(#fff, 0),
    rgba(#fff, 0.5),
    rgba(#fff, 0)
  );
  background-size: 40px 100%;
  background-repeat: no-repeat;
  background-position: left -40px top 0;
  `

// export const OtpInput = styled.input`
//   letter-spacing: 40px;
//   border: 0;
//   font-size: 1.2rem;
//   color: ${secondaryVariant};
//   background-image: linear-gradient(
//     to left,
//     ${secondaryVariant} 70%,
//     rgba(255, 255, 255, 0) 0%
//   );
//   background-position: bottom;
//   background-size: 50px 1px;
//   background-repeat: repeat-x;
//   background-position-x: 50px;
//   width: 300px;
//   height: 40px;
//   margin-bottom: 16px;
// `

// import React from 'react'
// import styled, { css } from 'styled-components'

export const AgeButton = styled.button`
  background-color: ${(props) => props?.bgcolor};
  border-radius: ${(props) =>
    props.borderradius ? props.borderradius : '100px'};
  color: ${(props) => props?.color};
  border: none;
  font-size: 5vw;
  padding: ${(props) => props?.padding};
  width: ${(props) => (props.width ? props.width : '')};
  opacity: ${(props) => (props.disabled ? 0.8 : 1)};
  border:1px solid ${(props) => (props.border ? props.border : 'none')}
  cursor: pointer;
  margin-right:${(props) => props.marginRight && props.marginRight};
  &:focus {
    outline: none;
  }
`

export const AgeTitle = styled.h5`
  font-size: 8vw;
  font-weight: 100;
  text-align: ${(props) => (props?.centered ? 'center' : null)};
`

export const BackDrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
`

export const SideDraw = styled.div`
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  width: 250px;
  z-index: 2;
  background-color: #fce792;
  overflow-y: scroll;
  transition: transform 0.3s ease-out;
  &.open {
    transform: translateX(0);
  }
`

export const Rank = styled.span`
  width: 50px;
  border: 1px solid #ffe36e;
  // border-radius:100%;
  padding: 10px 11px;
  font-size: 20px;
  font-weight: 900;
`

export const ScoreType = styled(Col)`
  background-color: ${(props) => props.bgcolor};
`
export const SelectBar = styled.h5`
  // border-right:1px solid lightgrey;
  padding: 13px 0px;
  color: ${(props) => props?.styling?.color};
  border-bottom: ${(props) => props.styling.borderBottom};
  margin: 0px;
  &:last-child {
    borderright: none;
  }
`
export const WorksheetContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 20px;
`
export const CorrectImageConatiner = styled.div`
  position: absolute;
  top: 100px;
  left: 100px;
`

export const Navlinks = styled.h5`
padding-top:10px;
padding-left:10px
  font-weight: 700;
  text-align: center;
  display:flex;
  justify-content:start;
  align-items:center;
`
export const TopParentsContainer = styled.div`
  height: 60px;
  width: 60px;
  border-radius: 100%;
  background-color: ${(props) => props.bgcolor};
`
export const OptionsBullets = styled.div`
  background: ${(props) => {
    if (props.selectedAns) {
      return props.selectedAns
    }
    return props.correct ? 'green' : props.wrong ? 'red' : null
  }}
  color:${(props) => {
    if (props.selectedAns) {
      return props.selectedAns
    }
    return props.correct ? 'white' : props.wrong ? 'white' : 'black'
  }}
  width: 100%;
  height: 100%;
  padding:0.7rem;
`
export const SidebarImageContainer = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 100%;
  background-color: ${(props) => props.bgcolor};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SidebarLinks = styled.h5`
  color: ${(props) => props.bgcolor};
  font-weight: 900;
`
export const QuizAnswerIndicator = styled(Image)`
  height: ${(props) => props.height};
  width: ${(props) => props.height};
  visibility: ${(props) => props.visibility};
`
export const Progressbar = styled(ProgressBar)`
  .progress-bar {
    background-color: ${(props) => props.color} !important;
    animation: ${(props) => rotate(props.width)} 1.5s ease-in-out forwards;
  }
`
const rotate = (width) => keyframes`
  from {
    width: 0%;
  }
  to {
   width: ${width};
  }
`

export const HomeScreenProgressBar = styled(ProgressBar)`
  .progress-bar {
    animation: ${(props) => rotate(props.width)} 1.5s ease-in-out forwards;
  }

  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`
